import React from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { List, ListItem } from "material-ui/List";
import Subheader from "material-ui/Subheader";
import Divider from "material-ui/Divider";
import Checkbox from "material-ui/Checkbox";
import Toggle from "material-ui/Toggle";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import {
  DEFAULT_ORDER,
  CUSTOMIZED_ORDER,
  ORDER_BY_CATEGORY,
  ORDER_BY_NAME,
  ORDER_BY_ASSESSMENT_TIER,
  updateResultsOrder,
  toggleLimitToTags,
  toggleHideTags,
  updateLimitedTags,
  updateHiddenTags,
  updateCategoryProp
} from "../actions/filterOptions";

const style = {
  width: 500
};

const bodyStyle = {
  // overflowY: "visible"
};


const OrderItem = ({ label, description, id, onClick, selected }) => (
  <ListItem
    style={{ backgroundColor: selected === id ? "#efefef" : "transparent" }}
    primaryText={label}
    onClick={() => onClick(id)}
    secondaryText={description}
  />
);

class FiltersAndSortingOptions extends React.PureComponent {
  render() {
    const {
      open,
      onRequestClose,
      section,
      order,
      updateResultsOrder,
      limitToTags,
      hideTags,
      toggleLimitToTags,
      toggleHideTags,
      hiddenTags,
      limitedTags,
      tags,
      categoryProp,
      onCategoryPropChange
    } = this.props;
    return (
      <Dialog
        autoScrollBodyContent={true}
        title="Sort Options"
        bodyStyle={bodyStyle}
        contentStyle={style}
        open={open}
        onRequestClose={onRequestClose}
      >
        {
          section === 'assessment' && (
            <React.Fragment>
              <Subheader style={{marginTop: 10}}>Category Display</Subheader>
              <RadioButtonGroup onChange={onCategoryPropChange} name="categoryProp" valueSelected={categoryProp || "Input-Based Category"} style={{paddingLeft: 16, marginBottom: 22}}>
                <RadioButton
                  value="Output-Based Category"
                  label="Assessment Output"
                />
                <RadioButton
                  value="Input-Based Category"
                  label="Assessment Categories"
                />
              </RadioButtonGroup>
              <Divider />
            </React.Fragment>
          )
        }
        <List>
          <Subheader>Display</Subheader>
          <OrderItem
            id={DEFAULT_ORDER}
            label="Default Order"
            description="Sorted by number of caveats with eliminated options below"
            onClick={updateResultsOrder}
            selected={order}
          />
          <OrderItem
            id={CUSTOMIZED_ORDER}
            label="Customized Sort Order"
            description="Options can be sorted manually by dragging and dropping"
            onClick={updateResultsOrder}
            selected={order}
          />

          {section=== 'assessment' && <OrderItem
            id={ORDER_BY_ASSESSMENT_TIER}
            label="Sort by assessment 'tiers'"
            onClick={updateResultsOrder}
            selected={order}
          />}
          <OrderItem
            id={ORDER_BY_NAME}
            label="Sort by option name"
            onClick={updateResultsOrder}
            selected={order}
          />
          <OrderItem
            id={ORDER_BY_CATEGORY}
            label="Sort by category"
            onClick={updateResultsOrder}
            selected={order}
          />
        </List>
        <Divider />
        <List>
          {
            tags && tags.length ? (
              <React.Fragment>
                <ListItem
                  rightToggle={
                    <Toggle toggled={limitToTags} onToggle={toggleLimitToTags} />
                  }
                  primaryText="Limit to specified characteristics (tags)"
                />
                {
                  tags.map((tag) => (
                    <ListItem leftCheckbox={<Checkbox disabled={!limitToTags} onCheck={(e, checked) => this.handleTagChecked(tag, checked)} checked={limitedTags.indexOf(tag.id) !== -1} />} key={"tag-" + tag.id} primaryText={tag.label} />
                  ))
                }
              </React.Fragment>
            ) : null
          }
        </List>
      </Dialog>
    );
  }

  handleTagChecked = (tag, checked) => {
    let newLimited = [...this.props.limitedTags];
    if (checked && newLimited.indexOf(tag.id) === -1) {
      newLimited.push(tag.id);
    } else {
      newLimited = newLimited.filter((id) => id !== tag.id);
    }
    this.props.updateLimitedTags(newLimited)
  }

}

const mapStateToProps = (state, ownProps) => ({
  section: ownProps.section,
  ...state.filterOptions[ownProps.section],
  tags: state.tags.filter(t => t.section === ownProps.section)
});

const mapDispatchToProps = (dispatch, props) => {
  const section = props.section;
  return {
    updateResultsOrder: order => dispatch(updateResultsOrder(section, order)),
    toggleHideTags: () => dispatch(toggleHideTags(section)),
    toggleLimitToTags: () => dispatch(toggleLimitToTags(section)),
    updateHiddenTags: ids => dispatch(updateHiddenTags(ids, section)),
    updateLimitedTags: ids => dispatch(updateLimitedTags(ids, section)),
    onCategoryPropChange: (e, value) => dispatch(updateCategoryProp(value, section))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  FiltersAndSortingOptions
);
